




























import {Component, Vue} from 'vue-property-decorator';
import ILanguage from '@/app/common/model/ILanguage';
import AppLangList from '@/app/common/component/AppLangList.vue';
import LoadingAnimation from '@/app/common/component/LoadingAnimation.vue';

@Component({components: {AppLangList, LoadingAnimation}})
export default class AuthView extends Vue {
  get currentLang(): string {
    return this.$store.getters.currentLang;
  }

  get loading(): string {
    return this.$store.getters.loading;
  }

  get languageList(): ILanguage[] {
    return this.$store.getters.languageList;
  }

  public setCurrentLang(shortcut: string) {
    this.$store.dispatch('setTranslation', shortcut);
  }
}
